import LeadAttributeWithFieldType from 'components/LeadInfo/LeadAttributeWithFieldType/LeadAttributeWithFieldType';

export default LeadAttributeWithFieldType;
